import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { TemplateService } from '@app-core/services';
import { OverlayRef } from '@app-core/services/overlay';
import { PrismicImageData } from '@app-model/api';
import { ButtonComponent } from '@app-shared/components/button/button.component';
import { IconComponent } from '@app-shared/components/icon/icon.component';
import { untilDestroyed } from '@app-shared/utils';
import { selectSmallLogo } from '@app-store/prismic/prismic.selectors';
import * as fromRoot from '@app-store/reducers';

@Component({
  templateUrl: './quote-saved-popup.component.html',
  styleUrls: ['./quote-saved-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonComponent],
})
export class QuoteSavedPopupComponent {
  private _store$ = inject<Store<fromRoot.State>>(Store);
  private _ref = inject<OverlayRef<QuoteSavedPopupComponent>>(OverlayRef);
  private _templateService = inject(TemplateService);

  readonly #untilDestroyed = untilDestroyed();

  printQuote(): void {
    this._store$
      .select(selectSmallLogo)
      .pipe(this.#untilDestroyed())
      .subscribe((navbarLogo: PrismicImageData) => {
        this._templateService.printQuote(navbarLogo?.url || '');
        this.close();
      });
  }

  close(): void {
    this._ref.close();
  }
}
